import { combineReducers } from 'redux-immutable';
import { createResponsiveStateReducer } from 'redux-responsive';

import { BREAKEPOINTS } from 'src/constants';
import { staticMap } from 'src/utils/immutableUtils';

// global store
import feedback from 'src/store/feedback/slices';
import client from 'src/store/client/reducers';
import logo from 'src/store/logo/reducers';
import menu from 'src/store/menu/slice';
import enqueue from 'src/store/enqueue/reducers';
import headerWidget from 'src/store/headerWidget/reducers';
import wishlist from 'src/store/wishlist/slice';
import roomPopup from 'src/store/roomPopup/slice';
import bannerAppData from 'src/store/appBanners/slice';
import headerBanner from 'src/store/headerBanner/slice';

import reviews from 'src/store/reviews/slice';
import cashback from 'src/store/cashback/slice';
import departures from './departures';
import map from './map';
import hotel from './hotel';
import extraItems from './extraItems';
import rooms from './rooms';
import searcher from './searcher';
import searchOffer from './searchOffer';
import view from './view';
import filters from './filters';
import { closestDatesReducer } from '../closestDates';

const rootReducer = combineReducers({
  feedback,
  client,
  logo,
  menu,
  enqueue,
  headerWidget,
  wishlist,
  //
  browser: createResponsiveStateReducer(BREAKEPOINTS),
  breadcrumbs: staticMap,
  hotel,
  view,
  reviews,
  airports: staticMap,
  ratings: staticMap,
  extraItems,
  images: staticMap,
  video: staticMap,
  rooms,
  searcher,
  departures,
  operators: staticMap,
  searchOffer,
  map,
  experiences: staticMap,
  bannerAppData,
  roomPopup,
  filters,
  headerBanner,
  closestDates: closestDatesReducer,
  cashback,
});

export default rootReducer;
